<template>
	<div class="sale-product">
		<!-- 导航 -->
		<!-- <van-nav-bar
			class="van-nav"
			title="商品列表"
			left-text="返回"
			left-arrow
			@click-left="goBack"
		/> -->
		<headerTemplate title="商品列表"></headerTemplate>

		<div class="max-content">
			<!-- 筛选项 -->
			<div class="filter">
				<van-dropdown-menu>
					<van-dropdown-item title="商品名称" ref="item">
						<van-field v-model="productName" label="商品名称" />
						<div style="padding: 5px 16px;">
							<van-button type="danger" block round @click="onConfirm">确认</van-button>
						</div>
					</van-dropdown-item>
					<van-dropdown-item v-model="classifyVal" :options="classifyOption" @change="onConfirm" />
					<van-dropdown-item title="价格筛选" ref="item">
						<van-field v-model="lowPrice" type="number" label="最低价格" />
						<van-field v-model="highPrice" type="number" label="最高价格" />
						<div style="padding: 5px 16px;">
							<van-button type="danger" block round @click="onConfirm">确认</van-button>
						</div>
					</van-dropdown-item>
					<van-dropdown-item title="库存筛选" ref="item">
						<van-field v-model="lowReserve" type="number" label="最低库存" />
						<van-field v-model="highReserve" type="number" label="最高库存" />
						<div style="padding: 5px 16px;">
							<van-button type="danger" block round @click="onConfirm">确认</van-button>
						</div>
					</van-dropdown-item>
				</van-dropdown-menu>
			</div>
			<!-- 商品展示 -->
			<table border="1">
				<tr>
					<th style="width: 60px;">ID</th>
					<th style="width: 200px;">商品名称</th>
					<th style="width: 50px;">库存</th>
					<th style="width: 50px;">市场价</th>
					<th style="width: 200px;">操作</th>
				</tr>
				<tr v-for="(item, i) in goodList" :key="i">
					<td>{{item.goods_commonid}}</td>
					<td class="goods-name">{{item.goods_name}}</td>
					<td>{{item.goods_storage_sum}}/{{item.goods_storage_total}}</td>
					<td>{{item.goods_price}}</td>
					<td style="text-align: center;">
						<van-button type="info" style="margin: 3px;" size="mini"
							@click="goProductInfo(item.goods_commonid, item.status, item.goods_lock, item.goods_addtime)">
							商品属性
						</van-button>
						<van-button v-if="item.status == 0" type="danger" size="mini"
							@click="uploadGoods(item.goods_commonid)">图片上传</van-button>
						<van-button v-else type="danger" size="mini" @click="updateNum(item.goods_commonid)">更新库存
						</van-button>
					</td>
				</tr>
			</table>
		</div>
		<van-pagination class="pagination" v-model="currentPage" :total-items="totalNum" :show-page-size="3"
			force-ellipses @change="changePage" />
	</div>
</template>

<script>
	import { getSellerGoods, updateStorageSelf, uploadGoods } from '../../../api/sale'
	import headerTemplate from '@/components/headerTemplate/headerTemplate'
	export default {
		name: 'SaleProduct',
		components: {
			headerTemplate
		},
		data() {
			return {
				// 商品名称
				productName: '',
				// 类别
				classifyVal: '',
				// 低高价
				lowPrice: '',
				highPrice: '',
				// 最低库存
				lowReserve: '',
				// 最高库存
				highReserve: '',
				// 当前页码
				currentPage: 1,
				// 获取到的货物列表
				goodList: [],
				classifyOption: [{
					text: '全部',
					value: '',
				}],
				// 总共的条数
				totalNum: 0
			}
		},
		methods: {
			// 返回上一页
			goBack() {
				this.$router.go(-1)
			},
			// 改变页码
			changePage() {
				getSellerGoods({
					search_goods_name: this.productName,
					goods_price_start: this.lowPrice,
					goods_price_end: this.highPrice,
					goods_storage_start: this.lowReserve,
					goods_storage_end: this.highReserve,
					choose_gcid: this.classifyVal,
					page: this.currentPage,
					pagesize: 10
				}).then(res => {
					// 货物列表
					this.goodList = res.result.goods_list
				}).catch(error => {
					// this.$router.push('Home')
				})
			},
			// 确认筛选-价格，商品名，库存
			onConfirm() {
				getSellerGoods({
					search_goods_name: this.productName,
					goods_price_start: this.lowPrice,
					goods_price_end: this.highPrice,
					goods_storage_start: this.lowReserve,
					goods_storage_end: this.highReserve,
					choose_gcid: this.classifyVal,
					page: this.currentPage,
					pagesize: 10
				}).then(res => {
					// 货物列表
					this.goodList = res.result.goods_list
				}).catch(error => {
					// this.$router.push('Home')
				})
			},
			// 商品详情
			goProductInfo(commonId, status, lock, addTime) {
				this.$router.push({
					name: 'ProductInfo',
					params: {
						commonId: commonId,
						status: status,
						lock: lock,
						addTime: addTime
					}
				})
			},
			// 手动更新库存
			updateNum(commonId) {
				updateStorageSelf(commonId).then(res => {
					alert('库存更新成功')
				}).catch(error => {
					// 
				})
			},
			// 上传商品
			uploadGoods(commonId) {
				uploadGoods(commonId).then(res => {
					alert('商品上传成功')
				}).catch(error => {
					// 
				})
			}
		},
		created() {
			getSellerGoods({
				search_goods_name: this.productName,
				goods_price_start: this.lowPrice,
				goods_price_end: this.highPrice,
				goods_storage_start: this.lowReserve,
				goods_storage_end: this.highReserve,
				choose_gcid: this.classifyVal,
				page: this.currentPage,
				pagesize: 10
			}).then(res => {
				this.classifyOption = res.result.goods_class.map(item => {
					return {
						text: item.gc_name,
						value: item.gc_id
					}
				})
				this.classifyOption.unshift({ text: '全部', value: '' })
				// 总共的条数
				this.totalNum = res.result.total
				// 货物列表
				this.goodList = res.result.goods_list
			}).catch(error => {
				// this.$router.push('Home')
			})
		}
	}
</script>

<style lang="scss" scoped>
	.sale-product {
		font-size: 14px;
		display: flex;
		flex-direction: column;

		.van-nav {
			z-index: 100;
			position: fixed;
			top: 0;
			width: 100%;
		}

		.max-content {
			z-index: 0;
			/* padding-top: 48px; */
			padding-bottom: 42px;
			height: calc(100% - 100px);
			overflow-y: scroll;

			.filter {

				.low-price-wapper,
				.high-price-wapper {
					display: flex;
				}
			}
		}

		.pagination {
			position: fixed;
			bottom: 0;
			width: 100%;
		}
	}

	.sale-product   ::v-deeptable {
		width: 100%;
		border: 1px solid #e2dddd;

		tr {

			th,
			td {
				text-align: center;
			}
		}
	}

	.sale-product   ::v-deep.van-button {
		margin-left: 0;
	}
</style>